import { render } from "./datasetDisplay.vue?vue&type=template&id=175ac3fc&scoped=true"
import script from "./datasetDisplay.vue?vue&type=script&lang=js"
export * from "./datasetDisplay.vue?vue&type=script&lang=js"

import "./datasetDisplay.vue?vue&type=style&index=0&id=175ac3fc&lang=css"
import "./datasetDisplay.vue?vue&type=style&index=1&id=175ac3fc&scoped=true&lang=css"

import exportComponent from "/tmp/build_b726cccb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175ac3fc"]])

export default __exports__